import Style from './PartnerLogo.style';

import gothaerLogo from 'img/b2b/gothaer-logo-w.svg';
import { useLocation } from 'react-router-dom';
import { linkHandler } from 'utils';

type LogoMapValue = {
  alt: string;
  src: string;
};

type LogoMap = Record<string, LogoMapValue>;

const logoMap: LogoMap = {
  [linkHandler.get('gothaerLandingPage')]: {
    alt: 'Bild: Gothaer Logo',
    src: gothaerLogo,
  },
};

export const PartnerLogo = () => {
  const { pathname } = useLocation();
  const logo = logoMap[pathname];

  return <Style>{logo && <img src={logo.src} className="icon" alt={logo.alt} />}</Style>;
};
